var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dbox-textarea-container deal"},[_c('textarea',{attrs:{"name":"deal","id":"deal"},domProps:{"value":_vm.first_offer_notes},on:{"blur":_vm.onBlur}})])}
var staticRenderFns = []

export { render, staticRenderFns }